import './AboutItem.css';

import * as React from 'react';
import * as Markdown from 'react-markdown';
import Placeholder from 'react-placeholder';
import styled from 'styled-components';

export interface IAboutItem {
  title?: string;
  content?: string;
  background?: string;
}

interface IProps {
  item: IAboutItem;
  loading: boolean;
  className?: string;
}

export const AboutItem: React.SFC<IProps> = props => {
  const background = props.item.background
    ? `url(${props.item.background})`
    : '';
  return (
    <Wrapper
      style={{ backgroundImage: background }}
      className={props.className}
    >
      <Container>
        <Inner>
          <Placeholder
            showLoadingAnimation={true}
            rows={1}
            ready={!props.loading}
          >
            <Title>{props.item.title}</Title>
          </Placeholder>
          <Placeholder
            showLoadingAnimation={true}
            rows={3}
            ready={!props.loading}
          >
            <Markdown
              className="about-markdown"
              source={props.item.content || ''}
            />
          </Placeholder>
        </Inner>
      </Container>
    </Wrapper>
  );
};

const Inner = styled.div``;

const Wrapper = styled.div`
  background-size: cover;
  background-position: right;
  background-repeat: no-repeat;
`;

const Container = styled.div`
  color: white;
  background-image: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000000 100%);
  padding: 80px 50px;
  @media (max-width: 900px) {
    padding: 15px;
  }
  height: 100%;
`;

const Title = styled.h3`
  font-size: 35px;
  font-weight: bold;
  text-transform: uppercase;
  @media (max-width: 900px) {
    font-size: 25px;
  }
`;

export default AboutItem;



// WEBPACK FOOTER //
// ./src/components/AboutItem/AboutItem.tsx